import useResizeObserver from 'resize-observer-hook';
import { useMetaContext } from '../../base';
import { GeoChartHeaderPicture } from './GeoChartHeaderPicture';

export const GeoChartHeaderPictureWrapper = () => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [ref, _, height] = useResizeObserver<HTMLDivElement>();
    const meta = useMetaContext();

    const isReady = ref !== undefined && meta.picture !== undefined;

    return (
        <div className="flex-grow overflow-hidden " ref={ref}>
            {isReady ? <GeoChartHeaderPicture width={meta.picture ? meta.picture.width : 0} height={height} /> : null}
        </div>
    );
};
